import { AppState } from 'Store'

const getAll = (state: AppState) => state.registratorCabinet.ordersList.rbidosRequest.entries
const getRequestParams = (state: AppState) => state.registratorCabinet.ordersList.requestParams
const getTotal = (state: AppState) =>
	state.registratorCabinet.ordersList.rbidosRequest.total_entries
const getCreateOptions = (state: AppState) => state.registratorCabinet.ordersList.createOptions
const getCreateOptionsLead = (state: AppState) =>
	state.registratorCabinet.ordersList.createOptionsLead
const getCreateOptionsCabinet = (state: AppState) =>
	state.registratorCabinet.ordersList.createOptionsCabinet

export const ordersListSelectors = {
	getAll,
	getTotal,
	getRequestParams,
	getCreateOptions,
	getCreateOptionsLead,
	getCreateOptionsCabinet,
}
